import { useClient } from "@/hooks/useClient";

const EmptyGuard = ({ children, data, title, cta, description, icon }) => {
  const { isClient } = useClient();

  return data?.length === 0 && isClient ? (
    <div className="flex items-center flex-col gap-2 py-10 sm:py-[20vh] justify-center">
      {icon || ""}
      <p className="font-bold text-[#77458F] text-lg sm:text-2xl">{title}</p>
      <p className="text-center text-zinc-500 max-w-96 max-sm:text-[15px]">
        {description}
      </p>
      {cta && (
        <button
          onClick={() => cta.callback()}
          className="py-2 font-semibold text-white rounded-md w-60 bg-primary"
        >
          {cta.label}
        </button>
      )}
    </div>
  ) : (
    <>{ isClient && children || ""}</>
  );
};

export default EmptyGuard;
